import React from "react";
import { Link } from "react-router-dom";

const WhiteButton = ({
  text,
  img,
  width,
  event,
  path,
  type = "button",
  uppercase = true,
  mutation = false,
}) => {
  return (
    <>
      {path ? (
        <Link
          to={path}
          className={`shadow-default bg-ternary text-white px-4 py-[7.8px] lg:text-[13px] text-xs rounded-md ${
            uppercase ? "uppercase" : "capitalize"
          } font-semibold flex justify-center items-center gap-2 tracking-wider relative z-20 outline-none ${
            width ? width : ""
          }`}
        >
          {text}
          {img && <img src={img} alt="" width={17} height={17} />}
        </Link>
      ) : (
        <button
          type={type}
          className={`shadow-default bg-white border-2 border-primary text-primary ${
            !mutation
              ? "lg:px-[40px] py-[11px] lg:text-[17px] text-xs"
              : "lg:px-[17px] py-[10px] lg:text-[15px] text-xs"
          }  rounded-md ${
            uppercase ? "uppercase" : "capitalize"
          } font-bold flex justify-center items-center gap-2 tracking-wider relative z-20 outline-none ${
            width ? width : ""
          }`}
          onClick={event}
        >
          {text}
          {img && <img src={img} alt="" width={17} height={17} />}
        </button>
      )}
    </>
  );
};

export default WhiteButton;
